import "./Summary.scss";

/**
 * Component: CartSummary
 */
export function CartSummary() {
  console.log("CartSummary mounted.");
}
